import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { inject, observer } from 'mobx-react';
import SelectComponent from '../../shared_components/SelectComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
@observer
class OverviewTableHeadMobileComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setFixedRateTerm = this.setFixedRateTerm.bind(this);
  }

  componentDidMount() {
    this.setFixedRateTerm(20);

    /*
      Update dom after update, because we are using ancient jquery semantic select.
      The actual value is set to 20 though.
    */
    $('select[name=selected-mobile-label]')
      .siblings('.text')
      .text('20 jaar');
  }

  setFixedRateTerm(value) {
    /* Always sort first overviewtable on mobile, because only visible one */
    this.props.OverviewData.setFirstOverviewTableColumnFixedRateTerm(Number(value));
    this.props.OverviewData.sortLabelInterestsByTermInterest(Number(value));
  }

  render() {
    const {
      /* All fixed rateterms including second one */
      allFixedRateTerms,
      firstOverviewTableColumnFixedRateTerm
    } = this.props.OverviewData;

    const allFixedRateTermsLabels = allFixedRateTerms.map(term => (
      { id: term, name: `${term} jaar`, value: term }
    ));

    return (
      <div className="mobile-only overview-container__table-head-mobile">
        <SelectComponent
          onChangeHandler={(e) => { this.setFixedRateTerm(e.target.value) }}
          selected={firstOverviewTableColumnFixedRateTerm}
          labels={allFixedRateTermsLabels}
          name="selected-mobile-label"
          label={'Product'}
          classNames={'small-84 search'}
        />
      </div>
    );
  }
}

OverviewTableHeadMobileComponent.propTypes = {
  OverviewData: PropTypes.shape({
    setFirstOverviewTableColumnFixedRateTerm: PropTypes.func,
    sortLabelInterestsByTermInterest: PropTypes.func,
    allFixedRateTerms: PropTypes.arrayOf(PropTypes.number),
  }),
};

OverviewTableHeadMobileComponent.defaultProps = {
  OverviewData: {
    setFirstOverviewTableColumnFixedRateTerm: () => {},
    sortLabelInterestsByTermInterest: () => {},
    allFixedRateTerms: [],
  },
};

export default inject('OverviewData')(OverviewTableHeadMobileComponent);
